import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

// Shown before another check/held bill/order replaces a cart with unsaved changes.
export function UnsavedCartDialog({ open, saving, onSave, onDiscard, onStay }) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!o) onStay(); }}>
      <AlertDialogContent data-testid="unsaved-cart-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Unsaved changes in the cart</AlertDialogTitle>
          <AlertDialogDescription>
            Opening another bill will replace the current cart. Save it first, discard the changes, or stay on this bill.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <Button variant="ghost" className="h-10" onClick={onStay} data-testid="unsaved-cart-stay-btn">Stay</Button>
          <Button variant="outline" className="h-10" onClick={onDiscard} data-testid="unsaved-cart-discard-btn">Discard</Button>
          <Button className="h-10" disabled={saving} onClick={onSave} data-testid="unsaved-cart-save-btn">
            {saving ? 'Saving…' : 'Save'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
